const NAMESPACE = "table";

const KEYS = {
    addLabel: "addLabel",
    importNewRowsButtonLabel: "importNewRowsButtonLabel",
    reorderLabel: "Reorder",
    removeLabel: "Remove",
    emptyTableText: "Table is empty",
    noTableSelected: "noTableSelected",
    rowHeader: "rowHeader",
    importNewRowsDialogHeader: "importNewRowsDialogHeader",
    reorderTableRowDialogHeader: "reorderTableRowDialogHeader"
};

const MESSAGES = {
    [KEYS.addLabel]: {
        value: "Add Row",
        comment: "Label for add new row"
    },
    [KEYS.importNewRowsButtonLabel]: {
        value: "Import New Rows",
        comment: "Label for a button that imports new rows to a table"
    },
    [KEYS.reorderLabel]: {
        value: "Reorder",
        comment: "Label for reorder row"
    },
    [KEYS.removeLabel]: {
        value: "Remove",
        comment: "Label for remove row"
    },
    [KEYS.emptyTableText]: {
        value: 'Table is empty. Click "Add Row" to enter data.',
        comment: "Text for table form element"
    },
    [KEYS.noTableSelected]: {
        value: "No table field selected."
    },
    [KEYS.rowHeader]: {
        value: "Row",
        comment: "Header for the 'Row' table column"
    },
    [KEYS.importNewRowsDialogHeader]: {
        value: "Import New Rows",
        comment: "Header for the 'import new rows' dialog"
    },
    [KEYS.reorderTableRowDialogHeader]: {
        value: "Reorder Table Row",
        comment: "Header for the 'reorder table row' dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
